(() => {
  if (customElements.get('cosmo-deferred-media')) return;
  class CosmoDeferredMedia extends HTMLElement {
    connectedCallback() {
      if (this.started || this.observer) return;
      if (window.Shopify?.designMode || !('IntersectionObserver' in window)) {
        this.activate();
        return;
      }
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.activate();
      }, { rootMargin: '300px 0px', threshold: 0 });
      this.observer.observe(this);
      this.addEventListener('focusin', this.activate, { once: true });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
    activate = async () => {
      if (this.started) return;
      const template = this.querySelector(':scope > template');
      if (!template) return;
      this.started = true;
      this.observer?.disconnect();
      const fragment = template.content.cloneNode(true);
      const scripts = Array.from(fragment.querySelectorAll('script')).filter(script => !script.type || /^(text\/javascript|application\/javascript|module)$/.test(script.type));
      const slots = scripts.map(script => {
        const marker = document.createComment('');
        script.replaceWith(marker);
        return marker;
      });
      template.replaceWith(fragment);
      for (let index = 0; index < scripts.length; index++) {
        const original = scripts[index];
        const script = document.createElement('script');
        for (const attribute of original.attributes) script.setAttribute(attribute.name, attribute.value);
        script.textContent = original.textContent;
        const completion = original.src ? new Promise(resolve => {
          script.addEventListener('load', resolve, { once: true });
          script.addEventListener('error', resolve, { once: true });
        }) : null;
        slots[index].replaceWith(script);
        if (completion) await completion;
      }
      this.querySelector(':scope > [data-cosmo-media-placeholder]')?.remove();
      this.setAttribute('data-loaded', '');
    };
  }
  customElements.define('cosmo-deferred-media', CosmoDeferredMedia);
})();
